module.exports = __webpack_public_path__ + "img/miley.44afe56c.jpg";